import { Skeleton, TableCell } from '@folio/components';
import { cn, formatPrice } from '@folio/lib';
import type { CellType } from 'korint-sdk/react';

const transforms: Record<CellType, (value: string | number) => React.ReactNode> = {
  price: (value: string | number) => (typeof value === 'number' ? formatPrice(value) : undefined),
  percentage: (value: string | number) => (typeof value === 'number' ? `${value} %` : value),
  text: (value: string | number) => `${value}`,
};

export function DataDisplay({
  value,
  defaultValue,
  isLoading,
  type,
}: {
  value: string | number | undefined | null;
  defaultValue?: string | number | null;
  isLoading?: boolean;
  type: CellType;
}) {
  const isNullish = value === null || value === undefined;
  const hasDefault = defaultValue !== null && defaultValue !== undefined;

  return isLoading ? (
    <Skeleton className="h-5 w-full" />
  ) : isNullish && !hasDefault ? (
    <div className="italic text-muted-foreground text-center">Indisponible</div>
  ) : (
    transforms[type](value ?? defaultValue!)
  );
}

export function DataCell({
  value,
  defaultValue,
  isLoading,
  className,
  type,
}: {
  value: string | number | undefined | null;
  defaultValue?: string | number | null;
  isLoading?: boolean;
  className?: string;
  type: CellType;
}) {
  return (
    <TableCell className={cn(className)}>
      <DataDisplay value={value} isLoading={isLoading} type={type} defaultValue={defaultValue} />
    </TableCell>
  );
}
